var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('b-container',[_c('b-row')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }